import { render } from "./ContainerRestartForm.vue?vue&type=template&id=33127015&scoped=true"
import script from "./ContainerRestartForm.vue?vue&type=script&lang=js"
export * from "./ContainerRestartForm.vue?vue&type=script&lang=js"

import "./ContainerRestartForm.vue?vue&type=style&index=0&id=33127015&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33127015"]])

export default __exports__